import { render, staticRenderFns } from "./VarietiesRepository.vue?vue&type=template&id=65179966&scoped=true&"
import script from "./VarietiesRepository.vue?vue&type=script&lang=js&"
export * from "./VarietiesRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65179966",
  null
  
)

export default component.exports